import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {FormSummaryValueModel} from '../../../../api/entity/formSummaryValue.model';
import {FormDefinitionFieldType} from '../../../../../definition/field/api/entity/formDefinitionFieldSummary.model';
import {FormValueModel} from "../../entity/formValue.model";
import {DocumentSummaryModel} from "../../../../../../document/common/api/model/documentSummary.model";
import {FormDefinitionFieldUtils} from "../../../../../definition/field/api/utils/formDefinitionField.utils";
import {FieldDefinitionUtils} from "../../../../../../../components/common/field/field-input/fieldDefinition.utils";
import {DialogController} from "../../../../../../common/dialog/dialogController";
import {
  ImagePreviewDialogComponent
} from "../../../../../../core/component/image-preview-dialog/image-preview-dialog.component";
import {ImageHelper} from "../../../../../../common/image/imageHelper";

@Component({
  selector: 'app-form-value-summary-field',
  templateUrl: './form-value-summary-field.component.html'
})
export class FormValueSummaryFieldComponent implements OnInit, OnChanges {

  @Input() imageMaxWidthPx = 200;
  @Input() imageMaxHeightPx = 200;
  @Input() displayLabel = true;
  @Input() value: FormValueModel | FormSummaryValueModel;
  FormDefinitionFieldType = FormDefinitionFieldType;
  entity: FormValueSummaryFieldComponentEntity;
  constructor(private dialogController: DialogController) { }

  ngOnInit() {
  }

  openImage(image: string) {
    this.dialogController.open(ImagePreviewDialogComponent, {
      image
    }, {
      title: 'Aperçu',
      width: '95%'
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value']) {
      this.entity = undefined;
      if (this.value) {
        console.log(['value', this.value]);
        if (this.value instanceof FormValueModel){
          console.log('value is FormValueModel');
          this.entity = {
            value: this.value.value,
            comment: this.value.comment,
            document: this.value.document,
            label: this.value.fieldDefinition?.summary?.shortLabel,
            typeValue: this.value.fieldDefinition?.summary?.type?.value,
            readableValues: []
          }
          FieldDefinitionUtils.resolveReadableValuesFromDefinition(this.value.value, this.value.fieldDefinition).then(values => {
            this.entity.readableValues = values.map(value1 => new FormValueSummaryFieldComponentEntityReadableValue(value1.value, value1.type))
          });

        }else {
          console.log('value is NOT FormValueModel');
          this.entity = {
            value: this.value.value,
            comment: this.value.comment,
            document: this.value.document,
            label: this.value.label,
            typeValue: this.value.typeValue,
            readableValues: [],
          }
          console.log(this.value.value);
          FieldDefinitionUtils.resolveReadableValues(this.value.value, this.value.typeValue,
              this.value.subTypeValue, this.value.unit, this.value.options).then(values => {
            this.entity.readableValues = values.map(value1 => new FormValueSummaryFieldComponentEntityReadableValue(value1.value, value1.type))
          });
        }
      }
    }
    /*
    // TODO check if necessary
    if (this.entity.value === true) {
      this.displayedValue = 'Oui';
    } else if (this.entity.value === false) {
      this.displayedValue = 'Non';
    }

    if (this.entity.comment) {
      this.displayedValue += '(' + this.entity.comment +')';
    } */

  }

  protected readonly open = open;
}

export class FormValueSummaryFieldComponentEntity {
  value: any;
  label: string;
  comment: string;
  document: DocumentSummaryModel;
  typeValue: string;
  readableValues: FormValueSummaryFieldComponentEntityReadableValue[];
}
class FormValueSummaryFieldComponentEntityReadableValue {
  readableValue: string;
  type: 'TEXT' | 'IMAGE' | 'DOCUMENT'

  constructor(readableValue: string, type: 'TEXT' | 'IMAGE' | 'DOCUMENT') {
    this.readableValue = readableValue;
    this.type = type;
    if (this.isImage) {
      this.readableValue = ImageHelper.addBase64MimeMarker(this.readableValue);
    }
  }

  get isImage(): boolean {
    return this.type === 'IMAGE';
  }
  get isDocument(): boolean {
    return this.type === 'DOCUMENT';
  }
}
